/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_RecentInputs */

const cs_documents_recent = /** @type {(inputs: Documents_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedávné složky`)
};

const en_documents_recent = /** @type {(inputs: Documents_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent folders`)
};

/**
* | output |
* | --- |
* | "Recent folders" |
*
* @param {Documents_RecentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_recent = /** @type {((inputs?: Documents_RecentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_RecentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_recent(inputs)
	return cs_documents_recent(inputs)
});